import { render } from "./VerRecetas.vue?vue&type=template&id=6da879fc&scoped=true"
import script from "./VerRecetas.vue?vue&type=script&lang=js"
export * from "./VerRecetas.vue?vue&type=script&lang=js"

import "./VerRecetas.vue?vue&type=style&index=0&id=6da879fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da879fc"]])

export default __exports__